import request from "utils/request";

// export async function getDetail(data) {
//   const response = await request({
//     url: "/ContentData/Get",
//     method: "get",
//     params: queryParams
//   });
//   return response.Result;
// }
/**
 * 获取导师和投资人数量 todo college
 * @param {*} params
 */
export function getTutorAndInvestorCount(params) {
  return request({
    url: "/Investment/GetTutorAndInvestorCount",
    method: "get",
    params
  });
}
/**
 * 获取导师数量 
 * @param {*} params
 */
export function getTutorCount(params) {
  return request({
    url: "/InnovationTutor/GetTutorCount",
    method: "get",
    params
  });
}
/**
 * 获取投资人数量 
 * @param {*} params
 */
export function getInvestorCount(params) {
  return request({
    url: "/Investment/GetInvestorCount",
    method: "get",
    params
  });
}
/**
 *添加浏览量 POST
 *
 * @export
 * @param {object} data
 * Match
 * @returns
 */
export function addViewCount(data) {
  return request({
    url: "/Match/AddViewCount",
    method: "post",
    data
  });
}

/**
 *获取评论列表 GET
 *
 * @export
 * @param {object} params
 * id
 * keyWord
 * sortType
 * sortName
 * pageSize
 * pageIndex
 * userId
 *
 * @returns
 */
export async function getCommentPagedList(params) {
  const response = await request({
    url: "/Match/GetCommentPageList",
    method: "get",
    params
  });
  return response.Result;
}

/**
 *删除赛事评论 POST
 *
 * @export
 * @param {object} params
 * matchCommentId
 *
 * @returns
 */
export function deleteCommentMatch(params) {
  return request({
    url: "/Match/DeleteCommentMatch",
    method: "post",
    params
  });
}

/**
 *添加赛事评论 POST
 *
 * @export
 * @param {object} params
 * Match
 * Comment
 * RelateReply
 * ReplyTo
 * @returns
 */
export function addCommentMatch(data) {
  return request({
    url: "/Match/AddComment",
    method: "post",
    data
  });
}

/**
 * 获取双创导师列表
 * @param {*} params
 */
export function getInnovationPageList(params) {
  return request({
    url: "/InnovationTutor/GetInnovationPageList",
    method: "get",
    params
  });
}
/**
 * 获取双创导师详情
 * @param {*} params
 */
export function getTutorDetail(id) {
  return request({
    url: '/InnovationTutor/GetTutorDetail/' + id,
    method: 'get'
  })
}
/**
 * 获取双创导师项目列表
 * @param {*} params
 */
export function getTutorPorject(params) {
  return request({
    url: '/InnovationTutor/GetTutorPorject',
    method: 'get',
    params
  })
}
/**
 * 查看双创项目列表 GET
 *
 * @export
 * @param {object} params
 * id
 * @returns
 */
export function getPageList(params) {
  return request({
    url: '/InnovationProject/GetPageList',
    method: 'get',
    params
  })
}
